import type { ComponentPropsWithoutRef } from 'react'
import { useSnapshot } from 'valtio'

import BlipChanged from '@/components/Icons/BlipChanged'
import BlipDefault from '@/components/Icons/BlipDefault'
import BlipNew from '@/components/Icons/BlipNew'
import { state } from '@/lib/state'
import { Flag } from '../../../../types'
import styles from './Legend.module.css'

function Icon({
  flag,
  ...props
}: { flag: Flag } & ComponentPropsWithoutRef<'svg'>) {
  switch (flag) {
    case Flag.New:
      return <BlipNew {...props} />
    case Flag.Changed:
      return <BlipChanged {...props} />
    case Flag.Default:
      return <BlipDefault {...props} />
  }
}

export function Legend() {
  const { radarConfig } = useSnapshot(state)
  const flags = radarConfig?.flags || {}
  return (
    <ul className={styles.legend}>
      {Object.entries(flags).map(([key, flag]) => (
        <li key={key}>
          <Icon flag={key as Flag} className={styles.icon} />
          <span className={styles.label}>{flag.description}</span>
        </li>
      ))}
    </ul>
  )
}
